import { createFileRoute } from "@tanstack/react-router";
import AdminTrainingOnDemandDetailPage from "@/pages/admin/lms/trainings-on-demand/detail";
import { useLmsPermissions } from "@/pages/admin/lms";

export const Route = createFileRoute("/app/admin/lms/trainings-on-demand/$trainingId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { trainingId } = Route.useParams();
  const {
    userCanAssociateMaterialsAndCriteria,
    userCanAssociateMaterialsAndTags,
    userCanAssociateMaterialsAndUserFunctions,
    userCanEditAllMaterials,
    userCanViewAllCriteria,
    userCanViewAllMaterials,
    userCanViewAllSettingTags,
    userCanViewAllTags,
  } = useLmsPermissions();

  return (
    <AdminTrainingOnDemandDetailPage
      id={Number(trainingId)}
      userCanAssociateMaterialsAndCriteria={userCanAssociateMaterialsAndCriteria}
      userCanAssociateMaterialsAndTags={userCanAssociateMaterialsAndTags}
      userCanAssociateMaterialsAndUserFunctions={userCanAssociateMaterialsAndUserFunctions}
      userCanEditAllMaterials={userCanEditAllMaterials}
      userCanViewAllCriteria={userCanViewAllCriteria}
      userCanViewAllMaterials={userCanViewAllMaterials}
      userCanViewAllSettingTags={userCanViewAllSettingTags}
      userCanViewAllTags={userCanViewAllTags}
    />
  );
}
